import Banner from './Banner'
import SectionDiferenctialsFirst from './SectionDiferentialsFirst'
import SectionDiferenctialsSecond from './SectionDiferentialsSecond'
import ReceiveNews from 'components/ReceiveNews'


export default function DiferenciaisPage({ data }) {
  return (
    <>
      <div className="container-full">
        <div className="container-geral flex-column">
          <Banner data={data.banner}/>
          <SectionDiferenctialsFirst data={data.secaoDiferenciaisFirstPart}/>
          <SectionDiferenctialsSecond data={data.secaoDiferenciasSecondPart} />
          <ReceiveNews data={data.secaoRecebaNovidades}/>
        </div>
      </div>
    </>
  )
}